export const handleTimeChange = (
  event: any,
  setTime: Function,
  setTimeError: Function,
  setFormattedTime: Function
) => {
  let newTimeString = inputString(event.target.value);
  newTimeString = autoFormatColon(newTimeString);
  newTimeString = trimToMaxLength(newTimeString);
  newTimeString = normalizeColonPlacement(newTimeString);

  setTime(newTimeString);

  if (newTimeString === "") {
    setTimeError("Time field is Mandatory");
    setFormattedTime("");
    return;
  }

  const timePattern = /^([01]?\d|2[0-3]):([0-5]?\d)$/;

  if (newTimeString.length === 5) {
    const [hoursStr, minutesStr] = newTimeString.split(":");
    const hours = Number(hoursStr);
    const minutes = Number(minutesStr);

    if (!isValidHourMinute(hours, minutes)) {
      setTimeError("Invalid time format. Only 23:59 is allowed at max.");
      return;
    }

    if (timePattern.test(newTimeString)) {
      try {
        const newFormattedTime = convertToISOTimeFormat(
          newTimeString,
          setTimeError
        );
        setFormattedTime(newFormattedTime);
        setTimeError(null);
      } catch (error) {
        console.error("Error converting time to ISO format:", error);
      }
    } else {
      setTimeError("Please provide time in HH:MM format.");
    }
  } else {
    setTimeError("Please provide time in HH:MM format.");
  }
};

const inputString = (value: string): string => {
  return value.replace(/[^0-9:]/g, "");
};

const autoFormatColon = (value: string): string => {
  return value.length === 3 && value[2] !== ":" && !value.includes(":")
    ? value.slice(0, 2) + ":" + value.slice(2)
    : value;
};

const trimToMaxLength = (value: string): string => {
  return value.length > 5 ? value.slice(0, 5) : value;
};

const normalizeColonPlacement = (value: string): string => {
  if (value.length === 0) return value;

  const hasColonAt3rd = value[2] === ":";
  return value.slice(0, 2) +
    (hasColonAt3rd ? ":" : "") +
    value.slice(hasColonAt3rd ? 3 : 2).replace(/:/g, "");
};

const isValidHourMinute = (hours: number, minutes: number): boolean => {
  return hours <= 23 && minutes <= 59;
};

  export const convertToISOTimeFormat = (time: string, setTimeError: Function) => {
    const timePattern = /^([01]?\d|2[0-3]):([0-5]?\d)$/;
  
    if (!timePattern.test(time)) {
      setTimeError("Please provide time in HH:MM format.");
      throw new Error("Invalid time format");
    }
  
    const [hours, minutes] = time.split(":");
    return `T${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}:00Z`;
  };

  export const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  };
